module.exports = __webpack_public_path__ + "empty-map-placeholder.143893a.png";